import type { ZeytalCLIPureConfig } from "@zeytal/kit";

import { zeytalDefaultConfig } from "@zeytal/kit";
import { loadConfig } from "c12";

export const getConfig = async (cwd?: string): Promise<ZeytalCLIPureConfig> => {
  const { config } = await loadConfig<ZeytalCLIPureConfig>({
    name: "zeytal",
    configFile: "zeytal",
    cwd,
    globalRc: false,
    dotenv: true,
    packageJson: false,
    envName: false,
    omit$Keys: true,
    jitiOptions: {
      extensions: [".json"],
    },
    defaultConfig: zeytalDefaultConfig,
  });

  const zeytalConfig: ZeytalCLIPureConfig = {
    ...config,
    projectToken: process.env.ZEYTAL_PROJECT_TOKEN ?? "",
  };

  return zeytalConfig;
};
